import { firebaseApp } from './firebase'

const checkValidPartnerId = () => {
  return firebaseApp
    .functions()
    .httpsCallable('checkValidPartnerId')()
    .then(result => result.data)
}

const getCoupon = couponCode => {
  return firebaseApp
    .functions()
    .httpsCallable('getCoupon')({
      couponCode
    })
    .then(result => result.data)
}

const createCreditCardToken = ({
  cardNumber,
  cardHolderName,
  cardExpMonth,
  cardExpYear,
  cardCvv
}) => {
  return firebaseApp
    .functions()
    .httpsCallable('createCreditCardToken')({
      cardNumber,
      cardHolderName,
      cardExpMonth,
      cardExpYear,
      cardCvv
    })
    .then(result => result.data)
}

const createSubscription = ({
  course,
  paymentMethod,
  cardTokenId,
  cardNumber,
  cardHolderName,
  cardExpMonth,
  cardExpYear,
  cardCvv,
  couponCode
}) => {
  return firebaseApp
    .functions()
    .httpsCallable('createSubscription')({
      course,
      paymentMethod,
      cardTokenId,
      cardNumber,
      cardHolderName,
      cardExpMonth,
      cardExpYear,
      cardCvv,
      couponCode
    })
    .then(result => result.data)
}

const cancelSubscription = () => {
  return firebaseApp
    .functions()
    .httpsCallable('cancelSubscription')()
    .then(result => result.data)
}

const getNeedToBePaidMonthsLeft = ({stripeSubscriptionId}) => {
  return firebaseApp
    .functions()
    .httpsCallable('getNeedToBePaidMonthsLeft')({
      stripeSubscriptionId
    })
    .then(result => result.data)
}

export const requests = {
  checkValidPartnerId,
  getCoupon,
  createCreditCardToken,
  createSubscription,
  cancelSubscription,
  getNeedToBePaidMonthsLeft,
}
